import styled from 'styled-components';
import { AccordionHeaderMixin } from '../../mixins/components/AccordionHeaderMixin';
export var StyledAccordionHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionHeader",
  componentId: "c11n-8-111-1__sc-pqgos7-0"
})(["", ""], AccordionHeaderMixin);